import React from "react";

function areArraysEqual(arr1, arr2) {
  if (arr1?.length !== arr2?.length) {
    return false;
  }

  const sortedArr1 = arr1?.slice()?.sort();
  const sortedArr2 = arr2?.slice()?.sort();

  for (let i = 0; i < sortedArr1?.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }

  return true;
}

/**
 * Sorts an array of items by their count property in descending order (highest count first)
 * @param {Array} items - Array of objects with a 'count' property
 * @returns {Array} - Sorted array by count in descending order
 */
function sortByCountDescending(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return [...items].sort((a, b) => {
    const countA = Number(a?.count || 0);
    const countB = Number(b?.count || 0);
    return countB - countA; // Descending order
  });
}

export { areArraysEqual, sortByCountDescending };
